var exports = {
  "k": "xa15a2ab7--199176--container",
  "S": "xa15a2ab7--199176--image",
};

module.exports = exports;
